import React from "react";
import DataGrid from '@dataGrid';
import GridConfig from "./GridConfig";
import { withStyles } from "@material-ui/core";
import styles from "./styles.js";
import { observer, inject } from "mobx-react";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import StatusBar from '@dataGrid/components/StatusBar';
import DriverInfoDialog from "../DriverInfoPopup";
import Events from "../../../../../../utilities/EventEmitter";
import appConstants from "../../../../../../appConstants";
import { DispatchChatBox } from "../../../DispatchChat";
import { notificationAudio } from "../../../DispatchChat/ChatSound";
import GroupMsgLayout from "../../GroupMsg/GroupMsgLayout";
import DispatchPanel from "../../DispatchPanel/index";
import CancelDispatch from "../../../Common/Modals/CancelDispatch";
import EndTripConfirmation from "../../EndTrip/EndTripConfirmation";
import {
  assignPickup,
  unassignPickup,
  reassignPickup,
  createAssignPickupDetails
} from '../../utils/pickupActions';
import { withFeatureFlags } from '../../../../../../userProfile/featureFlagsContext';
import { autorun } from 'mobx';
import { isEqual, isEmpty } from 'lodash/lang';
import {
  getSpecialNeedsOptionsWithServiceLevel,
  getGridFeatureFlagsByGridNames
} from '../../../../utils';
import EquipmentDefects from '../../DispatchPanel/EquipmentDefects';
import { DEFAULT_EQUIPMENT_TYPE } from '../../DispatchPanel/EquipmentDefects/constants';
import { uniqBy } from 'lodash';
import StopImagesDialog from '../../DriverPopUp/StopImagesDialog';
import {
  getLastCompletedPickupStop,
  getFilteredDriverBreakDelays,
  getDailyAccruedHours,
  getTerminalDateWithOffset,
  checkIsStartTripEnabled,
  checkIsEndTripEnabled
} from '../../../utils/utils';
import { withAppConfig } from '../../../../../../appConfigContext';
import { isDriverTimeBeforeCurrentDateAndTime } from '../../utils';
import { getProNumbers } from '../../DriverPopUp/utils';
import { postData, getDataWithDeduplication } from '../../../../../../api/componentAPIs';
import { getDefaultDateRange } from '../../../DispatchChat/MessageHistory/utils';
import MessageHistory from '../../../DispatchChat/MessageHistory';
import MESSAGES from '../../../../../../appMessages';
import { withSnackbar } from 'notistack';

@inject('DispatchStore', 'CommonStore')
@observer
class DriversGrid extends React.Component {
  constructor(props) {
    super(props);
    const gridFeatureFlagConfig = getGridFeatureFlagsByGridNames(
      this.props.configJSON?.gridConfiguration,
      appConstants.gridNames.DispatchedDriverGrid
    );
    this.gridConfig = new GridConfig({
      userProfile: this.props.userData.userProfile,
      featureFlags: {
        enableColumnShortForm: this.props.configJSON?.enableColumnShortForm,
        enableDriverZone:
          gridFeatureFlagConfig[
            appConstants.gridColumnFeatureFlag.DispatchedDriverGrid.EnableDriverZone
          ],
        enableWeeklyAccruedHours:
          gridFeatureFlagConfig[
            appConstants.gridColumnFeatureFlag.DispatchedDriverGrid.EnableWeeklyAccruedHours
          ],
        enableRestBreakInDelay: this.props.configJSON?.enableRestBreakInDelay
      }
    });
    this.gridHeaderId = `gridHeader_${this.props.glContainer._config.id}`;
    this.gridApi = {};
    this.state = {
      quickFilterText: '',
      open: false,
      selectedDispatchRoute: {},
      showDispatchPanel: false,
      isDispatchGroupMsgPopupOpen: false,
      openMessageHistory: false,
      isEquipmentDefectsModalOpen: false,
      onChatDriverId: null,
      cancelDisaptchData: null,
      showEndTripModal: false,
      trailerSpaceImagesData: null
    };
    this.terminalChangeRefresh = false;
    this.dispatchPanelDriver = {};
    this.drawerContainer = React.createRef();
    this.priorityShipmentList = this.props.DispatchStore.priorityAllShipmentList;
    this.gridContext = {
      terminalOffset: this.props.userData.userProfile.terminal.offset,
      enableDispatchDriver: this.props.featureFlags.isFeatureEnabled(
        appConstants.features.EnableDispatchDriver
      ),
      specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(this.priorityShipmentList),
      weeklyAllowedHOS: this.props.CommonStore.weeklyAllowedHOS,
      dailyAllowedHOS: this.props.CommonStore.dailyAllowedHOS,
      getDriverRoutes: this.getDriverRoutes,
      getDailyAccruedHours: this.getDailyAccruedHours,
      getLCT: this.getLCT
    };
    this.driverStatusUpdateTimer = null;
    this.isAnyFilterSet = false;
  }
  componentDidMount() {
    this.props.glEventHub.on(this.gridHeaderId, this.onSearchTextChanged);
    this.props.glEventHub.on(appConstants.Event.SELECT_PICKUP_ROUTES, this.selectPickupRoutes);
    this.props.glEventHub.on('openDriverGridModel', this.openModel);
    Events.on('RefreshComplete', this.onRowDataUpdated);
    this.props.glEventHub.on('OpenDriverChatBox', this.onOpenDriverChatBox);
    Events.on('MessageFromDriver', this.onMessageFromDriver);

    Events.on('AddDriverLocation', this.refreshDriverLastConnectedTime);
    this.props.glEventHub.on('SelectDriverRoutes', this.selectDriverRoutes);
    this.props.glEventHub.on('cancelDispatch', this.onCancelDispatch);
    this.props.glEventHub.on('createDispatch', this.openDispatchPanel);
    this.props.glEventHub.on('onShowEndTrip', this.onShowEndTrip);
    this.props.glEventHub.on('onShowStartTrip', this.onShowStartTrip);
    Events.on('refreshAvailableDrivers', this.refreshAvailableDrivers);
    Events.on('refreshUnreadMessages', this.getUnreadMessages);
    Events.on('DispatchStartTripCompleted', this.dispatchStartTripCompleted);

    this.autorunPriorityShipmentList = autorun(() => {
      if (!isEqual(this.priorityShipmentList, this.props.DispatchStore.priorityAllShipmentList)) {
        this.priorityShipmentList = this.props.DispatchStore.priorityAllShipmentList;
        this.gridContext = {
          ...this.gridContext,
          specialNeedsOptions: getSpecialNeedsOptionsWithServiceLevel(this.priorityShipmentList)
        };
      }
    });
    this.autorunParameterData = autorun(() => {
      const weeklyAllowedHOS = this.props.CommonStore.weeklyAllowedHOS;
      const dailyAllowedHOS = this.props.CommonStore.dailyAllowedHOS;
      if (
        this.gridContext.weeklyAllowedHOS !== weeklyAllowedHOS ||
        this.gridContext.dailyAllowedHOS !== dailyAllowedHOS
      ) {
        this.gridContext = {
          ...this.gridContext,
          weeklyAllowedHOS,
          dailyAllowedHOS
        };
      }
    });
    this.refreshAvailableDrivers();
    this.getUnreadMessages();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id
    ) {
      this.terminalChangeRefresh = true;
      this.setState({
        showDispatchGroupMsgBox: false,
        onChatDriverId: null
      });
      this.gridContext = {
        ...this.gridContext,
        terminalOffset: this.props.userData.userProfile.terminal.offset
      };
    }
    if (this.state.onChatDriverId) {
      const isDriverTripEnded =
        this.props.DispatchStore.currentActiveRoutes.findIndex(
          (route) => route.driverId === this.state.onChatDriverId
        ) === -1;
      if (isDriverTripEnded) {
        this.closeChatBox();
      }
    }
  }

  componentWillUnmount() {
    this.props.glEventHub.off(this.gridHeaderId, this.onSearchTextChanged);
    this.props.glEventHub.off(
      appConstants.Event.SELECT_PICKUP_ROUTES,
      this.selectPickupRoutes,
    );
    this.props.glEventHub.off("openDriverGridModel", this.openModel);
    Events.off("RefreshComplete", this.onRowDataUpdated);
    this.props.glEventHub.off("OpenDriverChatBox", this.onOpenDriverChatBox);
    Events.off("MessageFromDriver", this.onMessageFromDriver);
    this.props.glEventHub.off("SelectDriverRoutes", this.selectDriverRoutes);
    this.props.glEventHub.off("cancelDispatch", this.onCancelDispatch);
    this.props.glEventHub.off("createDispatch", this.openDispatchPanel);
    this.props.glEventHub.off("onShowEndTrip", this.onShowEndTrip);
    this.props.glEventHub.off("onShowStartTrip", this.onShowStartTrip);
    Events.off("AddDriverLocation", this.refreshDriverLastConnectedTime);
    Events.off("refreshAvailableDrivers", this.refreshAvailableDrivers);
    Events.off("refreshUnreadMessages", this.getUnreadMessages);
    Events.off("DispatchStartTripCompleted", this.dispatchStartTripCompleted);
    if (this.driverStatusUpdateTimer) {
      clearInterval(this.driverStatusUpdateTimer);
      this.driverStatusUpdateTimer = null;
    }
    this.autorunPriorityShipmentList?.();
    this.autorunSelectedPickupsListRef?.();
    this.autorunParameterData?.();
  }

  refreshAvailableDrivers = (signalRData) => {
    // If SignalR data is provided, update the store directly based on eventMode
    if (signalRData?.eventMode) {
      this.props.DispatchStore.updateAvailableDriverByEvent(signalRData);
      return;
    }

    // If no SignalR data provided, fetch from API (initial refresh case)
    getDataWithDeduplication(
      'GetAvailableDrivers',
      `terminalCode=${this.props.userData.userProfile.terminal.code}`
    )
      .then((response) => {
        let availableDrivers = [];
        if (response?.status === 200) {
          availableDrivers = response.data ?? [];
        }
        this.props.DispatchStore.setAvailableDriverList(availableDrivers);
      })
      .catch(() => {});
  };

  getUnreadMessages = () => {
    getDataWithDeduplication(
      'GetUnreadMessages',
      `terminalCode=${this.props.userData.userProfile.terminal.code}`
    )
      .then((unreadMessages) => {
        if (unreadMessages && unreadMessages.status === 200) {
          this.props.DispatchStore.addUnreadMessages(unreadMessages.data);
        } else {
          this.props.DispatchStore.addUnreadMessages([]);
        }
      })
      .catch(() => {});
  };

  refreshDriverLastConnectedTime = (driverLocationMap) => {
    const driverIds = [...driverLocationMap.keys()];
    this.gridApi.forEachNode?.((node) => {
      if (driverIds.includes(node.data.driverId.toUpperCase())) {
        this.gridApi.refreshCells({
          rowNodes: [node],
          columns: ['lct'],
          force: true
        });
      }
    });
  };

  getLCT = (driverId) => {
    const driver = this.props.DispatchStore.driverLocations[driverId.toUpperCase()];
    return driver?.lastConnectedTime;
  };

  getDailyAccruedHours = (driverId) => {
    const data = this.props.DispatchStore.getCurrentDriver(driverId);
    if (!data || !data.driverClockedInTime) {
      return 0;
    }
    const terminalOffset = this.props.userData.userProfile.terminal.offset;
    const driverStartTimeInUtcTime = getTerminalDateWithOffset(
      data.driverClockedInTime,
      terminalOffset
    );
    if (!isDriverTimeBeforeCurrentDateAndTime(data.driverClockedInTime, terminalOffset)) {
      return 0;
    }
    return getDailyAccruedHours({
      driverStartTime: driverStartTimeInUtcTime,
      lunchBreakStops: getFilteredDriverBreakDelays(
        data.delays,
        appConstants.DELAY_STOP_TYPES.LUNCH_BREAK
      ),
      terminalOffset
    });
  };

  getDriverRoutes = (driverId) => {
    return this.props.DispatchStore.getDriverRoutes(driverId);
  };

  onOpenDriverChatBox = (dataString) => {
    const data = JSON.parse(dataString);
    this.setState({
      onChatDriverId: data.driverId
    });
  };

  onCancelDispatch = () => {
    this.setState({
      cancelDisaptchData: this.gridApi.getSelectedRows().slice()[0]
    });
  };

  closeCancelDisaptchModal = () => {
    this.setState({
      cancelDisaptchData: null
    });
  };

  onMessageFromDriver = (driverMessageString) => {
    const driverMessage = JSON.parse(driverMessageString);
    const matchRoute = this.props.DispatchStore.currentActiveRoutes.find(
      (route) => route.driverId.toUpperCase() === driverMessage.sender.toUpperCase()
    );
    if (matchRoute && driverMessage.message.length > 0) {
      this.props.DispatchStore.addUnReadMessageCountToDriver(matchRoute.driverId);
      this.gridApi.forEachNode((node) => {
        if (matchRoute.routeId === node.data.routeId) {
          this.gridApi.refreshCells({ rowNodes: [node] });
        }
      });
      // Move this to notification panel when implmented

      notificationAudio.play();
    }
    if (this.state.onChatDriverId?.toUpperCase() !== driverMessage.sender.toUpperCase()) {
      Events.emit('showToastMessageNotification', driverMessageString);
      this.props.DispatchStore.addDispatchedDriverNotification([driverMessage]);
    }
  };

  closeChatBox = () => {
    this.setState({
      onChatDriverId: null
    });
  };

  openModel = (popupName) => {
    this.setState({
      [popupName]: true
    });
  };

  closeModel = () => {
    this.setState({
      isDispatchGroupMsgPopupOpen: false,
      isEquipmentDefectsModalOpen: false,
      openMessageHistory: false
    });
  };

  onMessageClick = (props) => {
    this.setState({
      onChatDriverId: props.routeData.driverId
    });
  };
  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.gridApi.runCommand = this.runCommand;
    this.selectRoutes(true, true);
    this.updateCancelDispatchStatus();
    this.startDriverRefreshInterval();
    this.autorunSelectedPickupsList();
  };

  autorunSelectedPickupsList = () => {
    this.autorunSelectedPickupsListRef = autorun(() => {
      if (
        !isEqual(this.gridApi.selectedPickupsList, this.props.DispatchStore.selectedPickupsList) ||
        !isEqual(this.filteredPickups, this.props.DispatchStore.filteredPickups)
      ) {
        this.filteredPickups = this.props.DispatchStore.filteredPickups;
        this.setSelectedVisiblePickupsInGrid();
        this.gridApi.refreshCells({ columns: ['actionCol'], force: true });
      }
    });
  };

  setSelectedVisiblePickupsInGrid = () => {
    const selectedPickups = this.props.DispatchStore.selectedPickupsList.slice();
    this.gridApi.selectedPickupsList = selectedPickups;

    //As of now selectedVisiblePickupsInGrid being used in driver grid action render logic only
    const selectedVisiblePickups = selectedPickups.filter((selectedPickup) =>
      this.props.DispatchStore.filteredPickups.some(
        (filteredPickup) =>
          selectedPickup.pickupId.toLowerCase() === filteredPickup.pickupId.toLowerCase()
      )
    );
    // Set the selected visible pickups in the grid
    this.gridApi.selectedVisiblePickupsInGrid = selectedVisiblePickups;
  };

  startDriverRefreshInterval = () => {
    this.driverStatusUpdateTimer = setInterval(() => {
      // Refresh available drivers list so it recalculates currentActiveDriver & which updates the driver status as well as the driver list
      const newAvailableDriverIds = this.props.DispatchStore.getShouldBeVisibleDrivers(
        this.props.DispatchStore.availableDriverList
      ).map((d) => d.driverId);
      const currentAvailableDriverId = this.props.DispatchStore.currentActiveRoutes.map(
        (d) => d.driverId
      );
      if (
        newAvailableDriverIds.filter((driverId) => !currentAvailableDriverId.includes(driverId))
          .length
      ) {
        this.props.DispatchStore.setAvailableDriverList(
          this.props.DispatchStore.availableDriverList
        );
      } else {
        this.gridApi.refreshCells({
          columns: ['elapsedTime', 'accruedHours', 'weeklyAccruedHours', 'currentDriverStatus'],
          force: true
        });
      }
    }, appConstants.ONE_MINUTE_TIME_OUT);
    this.gridApi.refreshCells({ columns: ['routeName'], force: true });
  };

  selectRoutes = (showRouteAnimation, ensureIndexVisible = false) => {
    this.setSelectedVisiblePickupsInGrid();
    this.selectDriverRoutes(
      this.props.DispatchStore.selectedDispatchDriverIdList,
      ensureIndexVisible,
      this.refreshSelection,
      showRouteAnimation
    );
  };

  selectDriverRoutes = (
    driverIdList,
    ensureIndexVisible = false,
    refreshSelection = true,
    showRouteAnimation = false
  ) => {
    this.refreshSelection = refreshSelection;
    if (this.gridApi && this.gridApi.forEachNode) {
      this.gridApi.forEachNode((node) => {
        if (driverIdList.includes(node.data.driverId)) {
          node.setSelected(true, false, true); // props are isSelected, clearOtherSelection, suppressFinishActions
          if (ensureIndexVisible) {
            this.gridApi.ensureIndexVisible(node.rowIndex);
          }
        } else {
          // disabling supress finish actions calls onSelectionChanged event for each selection
          node.setSelected(false, false, true); // but we want single call of onSelectionChanged for multiselection , behaviour observed through user action
        } // so we suppress the call from setSelected and call it explicitly after loop completes
      });
      this.props.glEventHub.emit('showRouteAnimationOnSelection', showRouteAnimation);
      this.props.glEventHub.emit('UpdateDispatchStore', 'updateSelectedDispatchDriver', [
        driverIdList
      ]);
      const selectedRouteIds = this.props.DispatchStore.currentActiveRoutes
        .filter((route) => route.routeId && driverIdList.includes(route.driverId))
        .map((route) => route.routeId);
      this.props.glEventHub.emit('UpdateDispatchStore', 'updateSelectedRoutes', [selectedRouteIds]);
      this.updateEndTripIconStatus();
      this.updateCancelDispatchStatus();
      this.gridApi.refreshCells({
        columns: ['routeName', 'driverLoginStatus', 'actionCol', 'closeTime', 'eta'],
        force: true
      });
    }
  };

  selectPickupRoutes = (refreshDriverSelection = true) => {
    if (this.gridApi) {
      this.setSelectedVisiblePickupsInGrid();
      const driverIdList = this.gridApi.selectedPickupsList
        .map((pickup) => pickup.driverId)
        .filter(Boolean);
      this.selectDriverRoutes(driverIdList, true, refreshDriverSelection, true);
    }
  };

  onSearchTextChanged = (searchText) => {
    this.setState({
      quickFilterText: searchText
    });
  };

  onRowDataUpdated = () => {
    this.selectRoutes(false);
    if (!isEmpty(this.gridApi)) {
      this.updateCancelDispatchStatus();
    }
  };

  updateCancelDispatchStatus = () => {
    const selectedDispatches = this.gridApi.getSelectedRows();
    let enableCancelDispatch = false;
    // Enable cancel dipatch if a single driver , which is already dispatched is selected
    if (selectedDispatches.length === 1 && selectedDispatches[0].dispatchId) {
      enableCancelDispatch = true;
    }
    this.props.glEventHub.emit(
      `${this.gridHeaderId}_updateCancelDispatchStatus`,
      enableCancelDispatch
    );
  };
  updateEndTripIconStatus = () => {
    const selectedDispatches = this.gridApi.getSelectedRows();
    let enableTripUpdate = false;
    let showStartTripIcon = false;
    if (selectedDispatches.length === 1) {
      if (
        checkIsEndTripEnabled({
          startEndTripWorkflow: this.props.configJSON.startEndTripWorkflow,
          routeStatus: selectedDispatches[0]?.routeStatus,
          driverRoutes: this.props.DispatchStore.getDriverRoutes(selectedDispatches[0].driverId)
        })
      ) {
        enableTripUpdate = true;
      } else if (
        checkIsStartTripEnabled({
          startEndTripWorkflow: this.props.configJSON.startEndTripWorkflow,
          routeStatus: selectedDispatches[0]?.routeStatus
        })
      ) {
        enableTripUpdate = true;
        showStartTripIcon = true;
      }
    }
    this.props.glEventHub.emit(
      `${this.gridHeaderId}_updateEndTripIconStatus`,
      enableTripUpdate,
      showStartTripIcon
    );
  };

  onSelectionChanged = () => {
    //this method is to be updated according to final implementation
    this.updateCancelDispatchStatus();
    this.updateEndTripIconStatus();
    if (this.gridApi && this.refreshSelection && !this.terminalChangeRefresh) {
      //terminalChangeRefresh is used to suppress the "selectionChanged" event fired due to "deltaRowDataMode" on driver grid when terminal is changed.
      const selectedRoutesList = [];
      const selectedDriverList = [];

      this.gridApi.getSelectedRows().forEach((route) => {
        route.driverId && selectedDriverList.push(route.driverId);
        route.routeId && selectedRoutesList.push(route.routeId);
      });
      if (
        selectedDriverList.length === 1 &&
        this.props.DispatchStore.selectedRouteNameList?.[0] !== selectedRoutesList[0]
      ) {
        this.props.glEventHub.emit(
          appConstants.Event.DISPATCH_ROUTE_SELECTED,
          selectedRoutesList,
          true
        );
      } else {
        this.props.glEventHub.emit(appConstants.Event.DISPATCH_ROUTE_SELECTED, selectedRoutesList);
      }
      this.props.DispatchStore.selectedDriverRouteId &&
        this.props.DispatchStore.updateSelectedDriverRouteId(null);
      this.props.glEventHub.emit('showRouteAnimationOnSelection', true);
      this.props.glEventHub.emit('UpdateDispatchStore', 'updateSelectedRoutes', [
        selectedRoutesList
      ]);
      this.props.glEventHub.emit('UpdateDispatchStore', 'updateSelectedDispatchDriver', [
        selectedDriverList
      ]);
      this.gridApi.refreshCells({ columns: ['routeName'], force: true });
    }
  };

  onDoubleClicked = (params) => {
    if (this.gridApi) {
      const driverRoutes = this.gridApi.getSelectedRows();
      if (driverRoutes.length) {
        this.setState({
          open: true,
          selectedDispatchRoute: {
            driverId: driverRoutes[0].driverId,
            routeId: driverRoutes[0].routeId
          }
        });
      }
    }
  };
  onCancel = () => {
    this.setState({
      open: false
    });
  };

  hideEndTripModal = () => {
    this.setState({
      showEndTripModal: false
    });
  };

  openDispatchPanel = (props) => {
    this.dispatchPanelDriver = this.props.DispatchStore.dispatchableDrivers.find(
      (d) => d.driverNumber === props?.driver?.driverNumber
    );
    this.setState({
      showDispatchPanel: true
    });
  };


  assignPickups = (data) => {
    const { driver } = data ?? {};
    const assignPickupDetails = createAssignPickupDetails(
      this.gridApi.selectedVisiblePickupsInGrid,
      { driverId: driver.driverId }
    );
    assignPickup({
      assignPickupDetails,
      terminalCode: this.props.userData.userProfile.terminal.code,
      glEventHub: this.props.glEventHub,
      DispatchStore: this.props.DispatchStore,
      enqueueSnackbar: this.props.enqueueSnackbar,
     });
  };

  unassignPickups = (data) => {
    const pickupsToUnassign = this.gridApi.selectedVisiblePickupsInGrid
      .filter((pickup) => pickup.driverId) // send only assigned pickup data in request payload when both assigned and unassigned pickups are selected and unassinged in dispatch
      .map((pickup) => ({ pickupId: pickup.pickupId.toLowerCase(), groupId: pickup.groupId }));
    unassignPickup({
      pickups: pickupsToUnassign,
      driverId: data.driver.driverId,
      terminalCode: this.props.userData.userProfile.terminal.code,
      glEventHub: this.props.glEventHub,
      DispatchStore: this.props.DispatchStore,
    });
  };

  reassignPickups = (data) => {
    const pickupDetails = createAssignPickupDetails(this.gridApi.selectedVisiblePickupsInGrid, {
      driverIdToAssign: data.driver.driverId
    }, true);

    reassignPickup({
      pickupDetails,
      terminalCode: this.props.userData.userProfile.terminal.code,
      glEventHub: this.props.glEventHub,
      DispatchStore: this.props.DispatchStore,
      enqueueSnackbar: this.props.enqueueSnackbar
    });
  };

  isPickupAssignmentLassoOpened = (command) => {
    // if PickupAssignmentLasso selected and dispatcher try to assing/unassign driver via driverGrid then close PickupAssignmentLasso PopUp
    ['Unassign', 'Assign', 'Reassign'].includes(command) &&
      this.props.glEventHub.emit('closePickupAssignmentLasso');
  };

  runCommand = (command, prop) => {
    this.isPickupAssignmentLassoOpened(command);
    switch (command) {
      case 'Unassign':
        this.unassignPickups(prop);
        break;
      case 'Assign':
        this.assignPickups(prop);
        break;
      case 'Reassign':
        this.reassignPickups(prop);
        break;
      case 'Dispatch':
        this.openDispatchPanel(prop);
        break;
      case 'openMessage':
        this.onMessageClick(prop);
        break;
      default:
        break;
    }
  };
  constructStatusBar = (filteredData) => {
    return [
      {
        label: filteredData.length + ' Drivers',
        filterCondition: ''
      }
    ];
  };

  closeDispatchPanel = () => {
    this.setState({
      showDispatchPanel: false
    });
  };

  onShowEndTrip = () => {
    if (this.gridApi) {
      const driverRoutes = this.gridApi.getSelectedRows();
      this.setState({
        selectedDispatchRoute: {
          driverId: driverRoutes[0].driverId,
          routeId: driverRoutes[0].routeId
        },
        showEndTripModal: true
      });
    }
  };

  onShowStartTrip = () => {
    if (!this.gridApi) {
      return;
    }
    this.props.glEventHub.emit('DispatchEvents', 'ShowLoaderDialog', ['Dispatch trip start']);
    const driverRoute = this.gridApi.getSelectedRows()[0];
    const requestData = {
      dispatchId: driverRoute.dispatchId,
      terminalCode: this.props.userData.userProfile.terminal.code,
      driverId: driverRoute.driverId,
      routeId: driverRoute.routeId,
      trailerNumber: driverRoute.trailerNumber,
      manifestNumber: driverRoute.manifestNumber,
      odometerReading: 0
    };
    postData('DispatchStartTrip', requestData)
      .then((response) => {
        if (response?.status !== 204) {
          this.onStartOfTripFailed(response);
        }
      })
      .catch((error) => {
        this.onStartOfTripFailed(error);
      });
  };

  onStartOfTripFailed = (response) => {
    const errorMessage = response?.response?.data.error.message || response?.message;
    this.props.glEventHub.emit('DispatchEvents', 'HideLoaderDialog', []);
    if (response?.status === 403) {
      return;
    }
    this.props.enqueueSnackbar(errorMessage || MESSAGES.START_TRIP.FAILURE, {
      variant: 'error'
    });
  };

  dispatchStartTripCompleted = (data) => {
    this.props.glEventHub.emit('DispatchEvents', 'HideLoaderDialog', []);
    const { success } = data;
    if (success) {
      this.props.enqueueSnackbar(MESSAGES.START_TRIP.SUCCESS, {
        variant: 'success'
      });
    } else {
      this.props.enqueueSnackbar(MESSAGES.START_TRIP.FAILURE, {
        variant: 'error'
      });
    }
  };

  onCellClicked = (params) => {
    const selectedDriverRoutes = this.gridApi.getSelectedRows();
    this.refreshSelection = true;
    if (params.column.colId === 'occCapacity' && selectedDriverRoutes.length === 1) {
      this.viewTrailerImages();
    }
  };

  onRowClicked = () => {
    if (this.terminalChangeRefresh) {
      this.terminalChangeRefresh = false;
    }
  };

  getDriversZoneDetails = () => {
    const driversZone = [];
    const zoneBasedDrivers = {};
    this.props.DispatchStore.currentActiveRoutes.forEach((dispatchDriver) => {
      if (!Boolean(Number(dispatchDriver.dispatchZone))) {
        return;
      }
      if (!zoneBasedDrivers[dispatchDriver.dispatchZone]) {
        zoneBasedDrivers[dispatchDriver.dispatchZone] = [];
      }
      driversZone.push({
        label: dispatchDriver.dispatchZone,
        value: dispatchDriver.dispatchZone
      });
      zoneBasedDrivers[dispatchDriver.dispatchZone].push(dispatchDriver.driverId);
    });
    return {
      driversZone: uniqBy(driversZone, 'value'),
      zoneBasedDrivers
    };
  };

  viewTrailerImages = () => {
    const selectedDriverRoute = this.gridApi.getSelectedRows();
    const { stopId, shipments } = getLastCompletedPickupStop(selectedDriverRoute[0].stops) || {};
    this.setState({
      trailerSpaceImagesData: {
        terminalCode: this.props.userData.userProfile.terminal.code,
        routeId: selectedDriverRoute[0].routeId,
        stopId,
        isStopCompleted: true,
        proNumbers: stopId ? getProNumbers(shipments) : [],
        stops: selectedDriverRoute[0].stops
      }
    });
  };

  onModelUpdated = () => {
    if (!this.gridApi) {
      return;
    }
    const isColumnFilterPresent = this.gridApi.isColumnFilterPresent?.();
    const isQuickFilterPresent = this.gridApi.isQuickFilterPresent?.();

    if (isColumnFilterPresent || isQuickFilterPresent) {
      this.isAnyFilterSet = true;
      const filteredRows = [];
      this.gridApi.forEachNodeAfterFilterAndSort?.((node) => {
        filteredRows.push(node.data);
      });
      this.props.glEventHub.emit('UpdateDispatchStore', 'updateFilteredDrivers', [filteredRows]);
    } else if (this.isAnyFilterSet) {
      this.props.glEventHub.emit('UpdateDispatchStore', 'updateFilteredDrivers', [
        this.props.DispatchStore.currentActiveRoutes
      ]);
      this.isAnyFilterSet = false;
    }
  };

  hideTrailerImages = () => {
    this.setState({
      trailerSpaceImagesData: null
    });
  };

  getSelectedDriverDispatchDetails = () => {
    return this.props.DispatchStore.getSelectedDriverCurrentRoutes()[0];
  };
  render() {
    const { classes } = this.props;
    const routes =
      this.props.DispatchStore.currentActiveRoutes.length > 0
        ? [...this.props.DispatchStore.currentActiveRoutes.slice()]
        : [];

    const selectedDriverRoute = this.props.DispatchStore.getDispatchRoute(
      this.state.selectedDispatchRoute?.routeId
    );
    return (
      <React.Fragment>
        <div className={classes.dataGrid} ref={this.drawerContainer}>
          <DataGrid
            defaultColDef={this.gridConfig.config.defaultColDef}
            columnDefs={this.gridConfig.config.columns}
            columnTypes={this.gridConfig.config.columnTypes}
            config={this.gridConfig.config}
            rowSelection={this.gridConfig.config.rowSelection}
            rowDeselection={this.gridConfig.config.rowDeselection}
            rowData={routes}
            onGridReady={this.onGridReady}
            onSelectionChanged={this.onSelectionChanged}
            panelLabel={(filteredData) => (
              <StatusBar data={this.constructStatusBar(filteredData)} />
            )}
            onCellDoubleClicked={this.onDoubleClicked}
            layoutContainer={this.props.glContainer}
            quickFilterText={this.state.quickFilterText}
            deltaRowDataMode={true}
            onRowDataUpdated={this.onRowDataUpdated}
            getRowId={(params) => params.data.driverId}
            onCellClicked={this.onCellClicked}
            onRowClicked={this.onRowClicked}
            showErrorMessage={this.props.DispatchStore.driversRouteGridMessage}
            rowClassRules={this.gridConfig.config.rowClassRules}
            context={this.gridContext}
            onModelUpdated={this.onModelUpdated}
            suppressRowVirtualisation={routes?.length < 300}
          />
        </div>
        {this.state.open && selectedDriverRoute && (
          <DriverInfoDialog
            terminalCode={this.props.userData.userProfile.terminal.code}
            onCancel={this.onCancel}
            driverInfo={selectedDriverRoute}
            userData={this.props.userData}
            onMessageClick={this.onMessageClick}
            priorityShipmentList={this.priorityShipmentList}
            glEventHub={this.props.glEventHub}
          />
        )}
        {this.state.onChatDriverId && (
          <DispatchChatBox driverId={this.state.onChatDriverId} onClose={this.closeChatBox} />
        )}
        {this.state.showDispatchPanel && (
          <DispatchPanel
            open={true}
            onClose={this.closeDispatchPanel}
            terminalCode={this.props.userData.userProfile.terminal.code}
            terminalOffset={this.props.userData.userProfile.terminal.offset}
            userProfile={this.props.userData.userProfile}
            driver={this.dispatchPanelDriver}
            glEventHub={this.props.glEventHub}
            allAvailableDriverList={this.props.DispatchStore.dispatchableDrivers}
            dispatchedDrivers={this.props.DispatchStore.dispatchedDrivers.map(
              (driver) => driver.driverId
            )}
          />
        )}
        {this.state.isEquipmentDefectsModalOpen && (
          <EquipmentDefects
            userProfile={this.props.userData.userProfile}
            onCancel={this.closeModel}
            defaultEquipmentType={DEFAULT_EQUIPMENT_TYPE}
          />
        )}
        {this.state.isDispatchGroupMsgPopupOpen && (
          <GroupMsgLayout
            onCancel={this.closeModel}
            isOpen={this.state.isDispatchGroupMsgPopupOpen}
            userData={this.props.userData}
            dispatchDrivers={this.props.DispatchStore.dispatchDrivers.slice()}
            driversZoneDetails={this.getDriversZoneDetails()}
          />
        )}

        {this.state.openMessageHistory && (
          <MessageHistory
            onClose={this.closeModel}
            defaultDriver={this.props.DispatchStore.activeDispatchedDriversList?.[0]?.value ?? null}
            defaultDateRange={getDefaultDateRange()}
            defaultTerminalCode={this.props.userData.userProfile.terminal.code}
            defaultTerminalOffset={this.props.userData.userProfile.terminal.offset}
            driverOptions={this.props.DispatchStore.activeDispatchedDriversList}
          />
        )}

        {this.state.cancelDisaptchData ? (
          <CancelDispatch
            data={this.state.cancelDisaptchData}
            onClose={this.closeCancelDisaptchModal}
            eventHub={this.props.glEventHub}
          />
        ) : null}
        {this.state.showEndTripModal ? (
          <EndTripConfirmation
            onCancel={this.hideEndTripModal}
            userData={this.props.userData}
            driverInfo={selectedDriverRoute ?? this.getSelectedDriverDispatchDetails()}
          />
        ) : null}
        {this.state.trailerSpaceImagesData ? (
          <StopImagesDialog
            refreshDriverRouteData={this.viewTrailerImages}
            showImages="trailer"
            {...this.state.trailerSpaceImagesData}
            close={this.hideTrailerImages}
            apiName={'GetImages'}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
export default compose(
  withUserProfile,
  withFeatureFlags,
  withStyles(styles),
  withAppConfig,
  withSnackbar
)(DriversGrid);
